/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var _get = require('lodash.get');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(formData) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      SubmitEntityContact: {
        $xmlns: 'http://dobs.pa.gov/dp/contact/bpm/1.0',
        Contact: {
          ContactID: formData.contactId,
          EntityID: formData.entityId,
          ContactTypeID: formData.contactTypeId,
          ContactTypes: {
            ContactTypeID: formData.entityContactTypes
          },
          FirstName: formData.firstName,
          LastName: formData.lastName,
          MiddleInitial: formData.middleInitial,
          Title: formData.title,
          PhoneNumber: formData.phoneNumber,
          IsDeleted: formData.isDeleted,
          AddressLine1: formData.addressLine1,
          AddressLine2: formData.addressLine2,
          AddressLine3: formData.addressLine3,
          County: formData.county,
          City: formData.city,
          State: formData.state,
          PostalCode: formData.postalCode,
          Country: formData.country,

          AdditionalNumbers: (function() {
            if (!_get(formData, 'additionalNumbers.length')) {
              return {};
            }
            return _.map(formData.additionalNumbers, function(additionalNumber) {
              return { AdditionalNumber: additionalNumber.additionalNumber };
            });
          })(),
          EmailAddresses: (function() {
            if (!_get(formData, 'emailAddresses.length')) {
              return {};
            }
            return _.map(formData.emailAddresses, function(email) {
              return { EmailAddress: email.emailAddress };
            });
          })()
        }
      }
    },
    blueprint: {
      contactId: '$..ContactID'
    }
  })
    .done(function(response) {
      cleanUpResponse(response, { cleanUpTextKeys: true });
      deferred.resolve(response.contactId);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
